import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "company-assessment-form-decimal" }
const _hoisted_2 = {
  key: 0,
  class: "displaymode-text"
}

import { computed } from "vue";
import type { PropType } from "vue";
import { companyAssessmentInputProps } from "./companyAssessmentInputProps";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyAssessmentFormDecimal',
  props: {
	modelValue: {
		type: [Number, String] as PropType<number | string | null>,
		required: true,
	},
	...companyAssessmentInputProps,
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const modelValue = computed({
	get: () => props.modelValue,
	set: (value: number | string | null) => emit("update:modelValue", value),
});

const displayText = computed(() => {
	if (modelValue.value === null || modelValue.value === undefined) return "";
	return modelValue.value.toString().replace(".", ",");
});

// Prevent non-digit input
function checkKey(event: KeyboardEvent) {
	if (
		![
			"Backspace",
			"Tab",
			"ArrowLeft",
			"ArrowRight",
			"ArrowUp",
			"ArrowDown",
			"Delete",
			"-", // Allow negative sign
			".", // Allow decimal point
			",", // Allow comma for decimal point
		].includes(event.key) &&
		!/^\d$/.test(event.key)
	) {
		event.preventDefault();
	}
}

return (_ctx: any,_cache: any) => {
  const _component_HakoInput = _resolveComponent("HakoInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.displayMode)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(displayText.value), 1))
      : (_openBlock(), _createBlock(_component_HakoInput, _mergeProps({
          key: 1,
          type: "number",
          step: "0.1",
          disabled: _ctx.displayMode,
          class: "form-control"
        }, _ctx.$attrs, {
          modelValue: modelValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
          onKeydown: checkKey
        }), null, 16, ["disabled", "modelValue"]))
  ]))
}
}

})